module.exports = __webpack_public_path__ + "media/icons/key-i-dark-a346b497.svg";